import * as React from 'react';
import { Banner } from 'labxchange-client';
import { Icon } from 'ui/components';
import { RichText } from 'elements/components/RichText';
import { SanitizeConfigOptions } from 'elements/utils/sanitization';

interface BannerItemProps {
    banner: Readonly<Banner>;
    dismiss: (banner: Banner) => void;
}

export class BannerItem extends React.Component<BannerItemProps> {
    public render() {
        const {banner} = this.props;

        return (
            <div className='banner-item'>
                <div className='banner-content'>
                    <h4>
                        <RichText
                            innerHtml={banner.content}
                            sanitizeConfig={SanitizeConfigOptions.UnsafeBannerHTML}
                            renderMathjax={false}
                        />
                    </h4>
                </div>
                {!banner.disableDismiss &&
                  <button
                      className='unstyled'
                      onClick={() => this.dismiss(banner)}
                  >
                      <span className='close-icon'>
                          <Icon name='x' zoom='14' />
                      </span>
                  </button>
                }
            </div>
        );
    }

    private dismiss = (banner?: Banner) => {
        if (banner?.id !== undefined) {
            this.props.dismiss(banner);
        }
    }
}
